export default __webpack_public_path__ + "static/media/img1.e58c5132.png";